import React, { CSSProperties } from "react";
import "./thinkingBackground.scss";

interface BackgroundProps {
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  speed?: number; // 1 is default speed, 2 is double speed, 0.5 is half
}

const ThinkingBackground: React.FC<BackgroundProps> = ({ children, className = "", style, speed = 2 }) => {
  return (
    <div
      className={`gradient-bg ${className}`}
      style={{ ...style, //@ts-ignore
        "--speed-mult": speed,
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg">
        <defs>
          <filter id="goo">
            <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8"
              result="goo"
            />

            <feBlend in="SourceGraphic" in2="goo" />
          </filter>

          <filter id="distortion">
            <feTurbulence type="fractalNoise" baseFrequency="0.005 0.005" numOctaves="1" seed="0" result="noise">
              <animate attributeName="baseFrequency" dur="20s" values="0.005;0.02;0.005" repeatCount="indefinite" />
            </feTurbulence>
            <feDisplacementMap in="SourceGraphic" in2="noise" scale="40" xChannelSelector="R" yChannelSelector="G" />
          </filter>
        </defs>
      </svg>

      <div className="gradients-container">
        <div className="g1" />
        <div className="g2" />
        <div className="g3" />
        <div className="g4" />
        <div className="g5" />
      </div>

      {/* Foreground content */}
      <div className="background-content">{children}</div>
    </div>
  );
};

export default ThinkingBackground;
